import React, { MouseEventHandler, useState } from "react";
import { ButtonProps, Theme } from "@literati/public-ui-shared-react";
import Divider from "@/atoms/Divider";
import SocialButtonsContainer from "components/authenticate/SocialButtonsContainer";
import { FormikChildrenRenderProps } from "components/Step/StepLayout";
import AuthFormTextInput from "components/authenticate/AuthFormTextInput";
import AuthFormToggle from "components/authenticate/AuthFormToggle";
import { AuthValues } from "components/authenticate/authTypes";

const CLASS_BASE = "auth-form-section-login";
export const AuthFormSectionLoginClassName = {
  TOGGLE_PARAGRAPH: `${CLASS_BASE}-toggle-paragraph`,
  TOGGLE_BUTTON: `${CLASS_BASE}-toggle-button`,
  SOCIAL_BUTTONS: `${CLASS_BASE}-social-buttons`,
} as const;

export interface AuthFormContentLoginProps
  extends FormikChildrenRenderProps<AuthValues> {
  onFormToggleClick?: MouseEventHandler<HTMLButtonElement>;
  onSocialLoginSuccess?: () => void;
  submitButtonProps?: ButtonProps;
}

export const AuthFormSectionLogin = ({
  errors,
  onFormToggleClick,
  onSocialLoginSuccess,
  submitCount,
}: AuthFormContentLoginProps) => {
  const cls = AuthFormSectionLoginClassName;

  const [loginBlurred, setLoginBlurred] = useState(false);
  const [passwordBlurred, setPasswordBlurred] = useState(false);

  return (
    <Theme>
      <AuthFormTextInput
        errors={errors}
        hasBlurred={loginBlurred}
        onBlur={() => setLoginBlurred(true)}
        submitCount={submitCount}
        variant="login"
      />
      <AuthFormTextInput
        css="margin: 1rem 0 0"
        errors={errors}
        hasBlurred={passwordBlurred}
        onBlur={() => setPasswordBlurred(true)}
        submitCount={submitCount}
        variant="password"
      />
      <>
        <Divider or />
        <div
          css={`
            max-width: 295px;
            margin: auto;
          `}
        >
          <SocialButtonsContainer
            className={cls.SOCIAL_BUTTONS}
            connectAccountUXType="dialog"
            disableAutoTap={true}
            onSuccess={onSocialLoginSuccess}
            width={384}
          />
        </div>
      </>
      <AuthFormToggle onClick={onFormToggleClick} variant="login" />
    </Theme>
  );
};

export default AuthFormSectionLogin;
